import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.pre`
    font-family: inherit;
    margin: 0;
    // font-weight: bold;
    white-space: pre-wrap;
`

const Pre = ({ children, ...props }) => {
    return (
        <Wrapper {...props}>
            {children}
        </Wrapper>
    );
}

export default Pre;
